import type { CompanyPlan } from '../services/companyConfigService';

export interface CompanyPlanOption {
  value: CompanyPlan;
  label: string;
  focus: string;
  monthlyPrice: string;
  description: string;
  setupFee: string;
  features: string[];
}

export const COMPANY_PLAN_OPTIONS: CompanyPlanOption[] = [
  {
    value: 'VITRINE_APP',
    label: 'Vitrine App',
    focus: 'Presença Digital',
    monthlyPrice: 'R$ 79,00/mês',
    setupFee: 'Setup: R$ 149',
    description:
      'Plano essencial para marcar presença digital no aplicativo coletivo Better Delivery e receber pedidos direto no painel.',
    features: [
      'Presença no app coletivo Better Delivery',
      'Gestão de pedidos básica (Painel + WhatsApp)',
      'Cadastro ilimitado de itens e combos',
      'Relatórios básicos de vendas',
    ],
  },
  {
    value: 'GESTAO_PLUS',
    label: 'Gestão Plus',
    focus: 'Controle Operacional',
    monthlyPrice: 'R$ 139,00/mês',
    setupFee: 'Setup: R$ 249',
    description:
      'Tudo do plano Vitrine com dashboards em tempo real, gestão de entregadores e campanhas de engajamento.',
    features: [
      'Dashboard de desempenho em tempo real',
      'Gestão de entregas com cadastro e vinculação de entregadores',
      'Relatórios de entrega por bairro e pagamentos',
      'Módulo de engajamento com cupons e mídias',
    ],
  },
  {
    value: 'WHITE_LABEL_BUSINESS',
    label: 'White-label Business',
    focus: 'Autoridade de Marca',
    monthlyPrice: 'R$ 189,00/mês',
    setupFee: 'Setup: R$ 349',
    description:
      'Tudo do plano Plus com site exclusivo no seu domínio, customização de marca e marketing integrado.',
    features: [
      'Site white-label exclusivo no seu domínio',
      'Customização de cores e logo da marca',
      'Autonomia total de domínio (ex.: seudominio.com.br)',
      'WhatsApp Marketing integrado',
    ],
  },
  {
    value: 'FULL_CONTROL_ENTERPRISE',
    label: 'Full Control Enterprise',
    focus: 'Inteligência e Estoque',
    monthlyPrice: 'R$ 299,00/mês',
    setupFee: 'Setup: R$ 499',
    description:
      'Tudo do plano Business com gestão de estoque avançada, planejamento financeiro e suporte prioritário.',
    features: [
      'Gestão de estoque avançada (saldos e movimentações)',
      'Ficha técnica detalhada por item',
      'Projeções financeiras e de vendas',
      'Relatórios avançados de estoque e CMV',
      'Suporte prioritário',
    ],
  },
];

export interface PlanCapabilities {
  paymentsEnabled: boolean;
  inventoryEnabled: boolean;
  loyaltyEnabled: boolean;
}

export const derivePlanCapabilities = (plan: CompanyPlan | undefined): PlanCapabilities => {
  switch (plan) {
    case 'FULL_CONTROL_ENTERPRISE':
      return { paymentsEnabled: true, inventoryEnabled: true, loyaltyEnabled: true };
    case 'GESTAO_PLUS':
    case 'WHITE_LABEL_BUSINESS':
      return { paymentsEnabled: true, inventoryEnabled: false, loyaltyEnabled: true };
    case 'VITRINE_APP':
    default:
      return { paymentsEnabled: false, inventoryEnabled: false, loyaltyEnabled: false };
  }
};
